'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');

var KayleeTutorials = {
    fromJson: fromJson,
    getTutorials: getTutorials,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseArray.$fromJson(data, 'Tutorials', reqProps, reqProps,
        function(data) { return getTutorials(); }
    );
}

function getTutorials() {
    var key = 'Tutorials';
    var tutorials = KayleeCache.get(key);

    if (tutorials === null) {
        tutorials = new Tutorials();
        KayleeCache.put(key, tutorials);
    }

    return tutorials;
}

function Tutorials() {
    this.$nodeType = 'tutorials';
    FirebaseArray.call(this, KayleeBase.app.database().ref('tutorials'));
    KayleeUtil.bindPrototypeMethods(Tutorials.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

Tutorials.prototype = Object.create(FirebaseArray.prototype);
Tutorials.prototype.constructor = Tutorials;

Tutorials.prototype.$toJson = function() {
    return FirebaseArray.prototype.$toJson.call(this, {}, []);
};

Tutorials.prototype.toString = function() {
    return '[Tutorials]';
};

module.exports = KayleeTutorials;